import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ISettingsDataResolveData } from './settings-data.data';
import { SettingsDataStore } from './settings-data.store';
import { Settings } from './settings.model';
import { map } from 'rxjs/operators';

@Injectable()
export class SettingsDataResolve implements Resolve<ISettingsDataResolveData> {
  static RESOLVE = {
    // key is the same as the RESOLVE_KEY in settings-data.data.ts
    settingsData: SettingsDataResolve,
  };

  constructor(private _settingsDataStore: SettingsDataStore) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<ISettingsDataResolveData> {
    return this._settingsDataStore
      .getSettings()
      .pipe(map((settings: Settings) => ({ settings })));
  }
}
